/**
 * @file components/biz/HooksForm/hooks/useStepForm
 * @author sunwen05
 */

import _ from 'lodash';
import {useState, useCallback} from 'react';
import {FormInstance} from 'acud/lib/form/Form';

import {StepControls, StepFormConfig} from './interface';

export default (
    form: FormInstance,
    steps: StepControls[],
    stepConfig: StepFormConfig = {},
    onSubmit: (values: any) => void,
    formData: any,
    setFormData: (formData: any) => void,
    setSubmiting: (isSubmiting: boolean) => void
) => {
    const [stepIndex, setStepIndex] = useState(0);

    const handlePrevStep = useCallback(async () => {
        const {prevClick, isSavedRealTime} = stepConfig;
        setSubmiting(true);
        const canPrev = !(_.isFunction(prevClick) && await prevClick() === false);
        if (canPrev) {
            if (isSavedRealTime) {
                setFormData((prevFormData: object) => ({
                    ...prevFormData,
                    ...form.getFieldsValue()
                }));
            }
            setStepIndex(stepIndex - 1);
        }
        setSubmiting(false);
    }, [stepIndex, form, setFormData, setSubmiting, stepConfig]);

    const buttonConfig = useCallback(() => {
        const stepLength = steps.length;
        const isFirst = stepIndex <= 0;
        const isLast = stepIndex >= stepLength - 1;
        const {prevText, nextText, endText} = stepConfig;
        return {
            type: 'button',
            config: [
                {
                    skin: 'default',
                    text: (prevText || '上一步'),
                    config: {
                        disabled: isFirst
                    },
                    events: {
                        onClick: () => handlePrevStep()
                    }
                },
                {
                    type: 'submit',
                    skin: 'primary',
                    text: isLast ? (endText || '确定') : (nextText || '下一步')
                }
            ]
        };
    }, [steps, stepConfig, stepIndex, handlePrevStep]);

    const doSubmit = useCallback(async values => {
        const nextClick = stepConfig.nextClick;
        const stepLength = steps.length;
        setSubmiting(true);
        const formDataMerge = {
            ...formData,
            ...values
        };
        const canNext = !(_.isFunction(nextClick) && await nextClick(formDataMerge) === false);
        if (canNext) {
            if ((stepIndex + 1) >= stepLength) {
                setSubmiting(false);
                onSubmit(formDataMerge);
            }
            else {
                setStepIndex(stepIndex + 1);
                setFormData((prevFormData: object) => ({
                    ...prevFormData,
                    ...values
                }));
                setSubmiting(false);
            }
        }
        else {
            setSubmiting(false);
        }
    }, [steps, stepConfig, onSubmit, stepIndex, formData, setFormData, setSubmiting]);

    return {
        stepIndex,
        buttonConfig,
        doStepSubmit: doSubmit
    };
};
